<script setup>
import { computed } from 'vue';
import { useI18n } from 'vue-i18n';
import { useRoute } from 'vue-router';
import { useFunctionGetter } from 'dashboard/composables/store';

import WootReports from './components/WootReports.vue';
import Spinner from 'dashboard/components-next/spinner/Spinner.vue';

const { t } = useI18n();
const route = useRoute();
const team = useFunctionGetter('teams/getTeamById', route.params.id);

const reportTitle = computed(
  () => team.value?.name || t('TEAM_REPORTS.HEADER')
);
</script>

<template>
  <WootReports
    v-if="team.id"
    :key="team.id"
    type="team"
    getter-key="teams/getTeams"
    action-key="teams/get"
    header-icon="i-lucide-users-round"
    header-accent="teal"
    back-route="team_reports_index"
    :selected-item="team"
    :download-button-label="$t('TEAM_REPORTS.DOWNLOAD_TEAM_REPORTS')"
    :report-title="reportTitle"
    :report-subtitle="$t('TEAM_REPORTS.DESCRIPTION')"
  />
  <div v-else class="w-full py-20">
    <Spinner class="mx-auto" />
  </div>
</template>
